var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shopping-mall"},[_c('shop-header',{attrs:{"headerTalg":false}}),_vm._t("default"),_c('shop-footer'),_c('fixedRightNav',{attrs:{"source":"shoppingMallStore"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }